import request from '@/utils/request'

const basePath = '/api/exam'


/**
 * 根据答题卡id获取答题卡（学生）
 * @param answerSheetId
 * @returns {AxiosPromise}
 */
export function getAnswerSheetById(answerSheetId) {
    return request({
        url: `${basePath}/answer/sheet/${answerSheetId}`,
        method: 'GET'
    })
}

/**
 * 根据答题卡id获取答题卡（管理员）
 * @param answerSheetId
 * @returns {AxiosPromise}
 */
export function getAnswerSheetByAdmin(answerSheetId) {
    return request({
        url: `${basePath}/answer/sheet/${answerSheetId}/admin`,
        method: 'GET'
    })
}

/**
 * 根据试卷id获取答题卡
 * @param examPaperId
 * @returns {*}
 */
export function getAnswerSheet(examPaperId) {
    return request({
        url: `${basePath}/answer/sheet`,
        method: 'POST',
        data: {
            examPaperId: examPaperId
        }
    })
}

/**
 * 获取当前答题卡的答案
 * @returns {AxiosPromise}
 */
export function getCurrentAnswer() {
    return request({
        url: `${basePath}`,
        method: 'GET'
    })
}

/**
 * 交卷
 * @returns {*}
 */
export function commitFinalAnswer() {
    return request({
        url: `${basePath}/answer/sheet`,
        method: 'PUT'
    })
}


